import React, { useState } from 'react';

import { CloseModal } from 'common/module/ui/lazy-modal';
import { ADD_TO_COLLECTION } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import trans from 'common/tools/translations/trans';

import allocineContainer from 'website/containers/allocineContainer';
import { Entity, isMovie, isSeries, SocialAction } from 'website/types';

import AddToExistingCollection from './AddToExistingCollection';
import AddToNewCollection from './AddToNewCollection';

type AddToCollectionModalProps = {
  closeModal: CloseModal;
  entity?: Entity | SocialAction;
};

const AddToCollectionModal = ({
  closeModal,
  entity
}: AddToCollectionModalProps) => {
  const [step, setStep] = useState('existing');

  // escape mouse event argument
  const handleClose = () => closeModal();
  const handleNewCollectionRequest = () => setStep('new');

  return (
    <ReactModal size="medium" title={trans('bam.more.add-to-collection')}>
      {step === 'existing' ? (
        <AddToExistingCollection
          entity={entity}
          onNewCollectionRequest={handleNewCollectionRequest}
          onClose={handleClose}
        />
      ) : (
        (isMovie(entity) || isSeries(entity)) && (
          <AddToNewCollection entity={entity} onClose={handleClose} />
        )
      )}
    </ReactModal>
  );
};

export { AddToCollectionModal as AddToCollectionForTest };

export default buildReactDomModalModule<{ entity?: Entity | SocialAction }>(
  ADD_TO_COLLECTION,
  ({ entity }, closeModal) => {
    const ConnectedAddToCollectionModal =
      allocineContainer(AddToCollectionModal);
    return (
      <ConnectedAddToCollectionModal closeModal={closeModal} entity={entity} />
    );
  }
);
